import { FC } from 'react';
import { NavigationPanelStrings } from '../../localization/en';
import { useTypedSelector } from '../../../store/store';
import { Container, TabItem } from './NavigationPanel.styles';
import { UploadProcessStep } from '../../../store/storeModels';

interface Props {
  activeIndex: number;
  isSharePage?: boolean;
}

export const NavigationPanel: FC<Props> = ({ activeIndex, isSharePage }) => {
  const { currentCampaign } = useTypedSelector((state) => state.rewards);
  const { currentStep } = useTypedSelector((state) => state.upload);

  const uploadStep =
    currentStep === UploadProcessStep.Uploaded || isSharePage
      ? NavigationPanelStrings.Uploaded
      : currentStep === UploadProcessStep.VideoUploading
      ? NavigationPanelStrings.Uploading
      : NavigationPanelStrings.Upload;

  const tabItems = [NavigationPanelStrings.Welcome, uploadStep, NavigationPanelStrings.Complete];

  const renderItems = tabItems.filter(
    (_, index) => (currentCampaign?.welcomeVideoUrl && currentCampaign?.showWelcomeVideo) || index > 0,
  );

  return <></>;

  return (
    <Container>
      {renderItems.map((tabName, index) => {
        const isActiveIndex = index === activeIndex;

        return (
          <TabItem
            key={tabName}
            sx={{
              borderTop: isActiveIndex ? 'unset' : '1px solid #2D11AD',
              borderBottom: isActiveIndex ? '1px solid #2D11AD' : 'unset',
              borderRight: isActiveIndex && index < renderItems.length - 1 ? '1px solid #2D11AD' : 'unset',
              borderLeft: isActiveIndex && index > 0 ? '1px solid #2D11AD' : 'unset',
              color: isActiveIndex || tabName === NavigationPanelStrings.Uploading ? '#2D11AD' : '#999',
              background: isActiveIndex
                ? 'transparent'
                : index < activeIndex
                ? 'rgba(0, 0, 0, 0.10)'
                : 'rgba(255, 255, 255, 0.60)',
            }}
          >
            {tabName}
          </TabItem>
        );
      })}
    </Container>
  );
};
